/* es5-ext/object/keys/index */ function _(require, module, exports) {
    module.exports = require(349) /* ./is-implemented */()
        ? Object.keys
        : require(350) /* ./shim */;
}
